<template>
    <nav class="pagination" role="navigation" aria-label="pagination">
        <ul class="pagination-list">
            <li><a class="pagination-link" disabled><i class="fas fa-arrow-left"></i></a></li>
            <li><a class="pagination-link" disabled><i class="fas fa-arrow-right"></i></a></li>
        </ul>
    </nav>
</template>

<script>
export default {
    name: 'PaginatorSkeleton',
};
</script>

<style scoped>

</style>
